<template>
  <draggable class="collection-items" :class="{ 'no-items' : !hasItems }" tag="ul" :list="items" :group="{ name: 'g1' }" :delay="100" :delayOnTouchOnly="true" :swapThreshold="0.7" :forceFallback="true" :fallbackTolerance="5" @start="$emit('start')" @end="$emit('end')">
    <li v-for="el in items" class="draggable-item draggable-item-collected" :key="el.key">
      <span>
        <img :src="getImgUrl(el.icon)" :alt="el.name" />
        {{el.name}}
        <button class="delete-item" @click="removeItem(el)"></button>
      </span>
      <ul v-if="el.children !== undefined">
        <li v-for="child in el.children" :key="child.key" class="item-children">
          {{child.name}}
        </li>
      </ul>
      <nested :items="el.items" @start="$emit('start')" @end="$emit('end')" @deleted-item="emitDelete()" />
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'Nested',
  props: {
    items: {
      required: true,
      type: Array
    },
    group: {
      type: String
    }
  },
  components: {
    draggable
  },
  methods: {
    getImgUrl (icon) {
      var images = require.context('../assets/img/icons/items/', false, /\.svg$/)
      return images('./' + icon + '.svg')
    },
    removeItem: function (item) {
      this.items.splice(this.items.indexOf(item), 1)
      this.emitDelete()
    },
    emitDelete: function () {
      this.$emit('deleted-item')
    }
  },
  computed: {
    hasItems: function () {
      if (this.items.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
</style>
